interface SPDomain {
  domainSession: string
  domainUser: string
}

function getSPDomainData(): SPDomain {
  const matcher = new RegExp('_sp_id\\.[a-f0-9]+=([^;]+);?')
  const matchedValue = document.cookie.match(matcher)
  if (matchedValue != null) {
    const snowplowValues = matchedValue[1].split('.')
    return { domainSession: snowplowValues[0], domainUser: snowplowValues[5] }
  }
  return { domainSession: null, domainUser: null }
}

export { getSPDomainData }
